module.exports = __webpack_public_path__ + "static/media/bar-vertical.c99aea3e.svg";